// Client-side mirror of server/services/passwordPolicy.js.
// Used for real-time UX feedback only — the backend is the security authority.

export const PASSWORD_RULES = [
  { key: 'length',  label: 'At least 12 characters',       test: p => p.length >= 12 },
  { key: 'upper',   label: 'One uppercase letter (A–Z)',    test: p => /[A-Z]/.test(p) },
  { key: 'lower',   label: 'One lowercase letter (a–z)',    test: p => /[a-z]/.test(p) },
  { key: 'number',  label: 'One number (0–9)',              test: p => /[0-9]/.test(p) },
  { key: 'special', label: 'One special character',         test: p => /[^A-Za-z0-9]/.test(p) },
];

export const isPasswordValid = (p = '') => PASSWORD_RULES.every(r => r.test(p));

export function passwordYupTests() {
  return {
    min12:   { test: p => !p || p.length >= 12,              message: 'At least 12 characters' },
    upper:   { test: p => !p || /[A-Z]/.test(p),             message: 'At least one uppercase letter (A–Z)' },
    lower:   { test: p => !p || /[a-z]/.test(p),             message: 'At least one lowercase letter (a–z)' },
    number:  { test: p => !p || /[0-9]/.test(p),             message: 'At least one number (0–9)' },
    special: { test: p => !p || /[^A-Za-z0-9]/.test(p),      message: 'At least one special character' },
  };
}
